export interface Camera {
  id: string;
  label?: string;
}
